import apiAuth from '@/apiAuth';

export default {
  session() {
    return apiAuth().get('/api/1.0/session');
  },

  keepAlive() {
    return apiAuth().get('/api/1.0/session/keep-alive');
  },

  authorize() {
    const params = new URLSearchParams({
      client_id: 'viddis-auth',
      scope: 'openid',
    });
    window.location.href = `${window.config.authUrl}/authorize?${params.toString()}`;
  },

  authorizeGoogle() {
    window.location.href = window.config.googleAuthUrl;
  },

  status() {
    return apiAuth().get('/api/1.0/session');
  },

  async logout() {
    const ret = await apiAuth().delete('/api/1.0/session');
    window.localStorage.removeItem('viddis-sessionkey');
    window.localStorage.removeItem('viddis-session');
    return ret;
  },

  userAgreement() {
    return apiAuth().get('/api/1.0/session/usage_agreement');
  },

  updateUserAgreement(data) {
    return apiAuth().post('/api/1.0/session/usage_agreement', data);
  },

  acceptUserAgreement() {
    return apiAuth().patch('/api/1.0/session', { agree: true });
  },

  organizations() {
    return apiAuth().get('/api/1.0/session/organizations');
  },

  roles() {
    return apiAuth().get('/api/1.0/session/roles');
  },

  selectRole(roleCode) {
    return apiAuth().patch('/api/1.0/session', {
      organization: '',
      role: roleCode,
      positionId: 0,
    });
  },

  selectOrganization(code) {
    return apiAuth().patch('/api/1.0/session', {
      organization: code,
    });
  },

  createTransferToken() {
    return apiAuth().put('/api/1.0/transfer');
  },
};
